import { AspectRatio, Box, Flex, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const ReviewItem = ({
  title,
  description
}: {
  title: string
  description: string
}) => {
  return (
    <VStack
      bg="white"
      py={6}
      px={4}
      my={4}
      borderRadius={10}
      w={300}
      alignItems="flex-start"
    >
      <AspectRatio w={100} ratio={100 / 16} position="relative">
        <Image
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/stars-1711000517589.png"
          alt="Stars"
          fill
        />
      </AspectRatio>
      <Text textStyle="docReviewItemTitle">{title}</Text>

      <Text textStyle="docReviewItemDesc">{description}</Text>
    </VStack>
  )
}

const Review = () => {
  return (
    <VStack w={600} pb={10}>
      <VStack
        mt={20}
        w="100%"
        alignItems={{
          base: 'center',
          md: 'flex-start'
        }}
        justifyContent="flex-start"
      >
        <Text textStyle="docReviewTitle" fontWeight={400}>
          What They Say About
        </Text>

        <Text
          textTransform="uppercase"
          textStyle="docReviewTitle"
          textAlign={{
            base: 'center',
            md: 'left'
          }}
        >
          DOCTORCOS
          <br /> SNOW WHITE GLOW MASK
        </Text>
      </VStack>

      <Flex
        justifyContent="space-between"
        alignItems="center"
        flexDir={{
          base: 'column',
          md: 'row'
        }}
      >
        <AspectRatio w={250} ratio={1 / 1} position="relative">
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/doctorcos-1711000496078.png"
            alt="Hero"
            fill
          />
        </AspectRatio>

        <Box>
          <ReviewItem
            title="Great Product !"
            description="Have been using for a year plus, keep my face moisturise. The product is not greasy after applying!"
          />
          <ReviewItem
            title="Recommended !"
            description="Bought for my mother and her complexion improved leaps n bounds! She told me her skin is softer n feels hydrated."
          />
          <ReviewItem
            title="Love this Mask !"
            description="Skin feel soft and moist without the greasy sticky feeling. It really works to ease the itch due to dryness."
          />
        </Box>
      </Flex>
    </VStack>
  )
}
export default Review
